import { ManagePayItems } from '../../../cimsPage/instances/payItems'
import { CreateViewEditSoftRemoveRestore, Simple } from '../../common'

const object = 'Pay Item Connection'

const groups = CreateViewEditSoftRemoveRestore({
  object: `${object} Group`,
  page: ManagePayItems,
  create: 'e5d8687b-451a-49de-83b5-020a9088b44e',
  view: 'b6559aba-60a5-40a3-b2f5-0cdbdbafe6ff',
  edit: '50bb60e0-981c-4174-876e-77944fdfe4ba',
  removeRestore: 'f819d646-caae-4b94-9597-0e63a2041acb',
})

const connections = CreateViewEditSoftRemoveRestore({
  object,
  page: ManagePayItems,
  create: '7746cecf-5d9e-417a-8afa-48f78a23b8e1',
  view: 'f877598d-e47f-464b-8bf0-f3a93019f136',
  edit: 'b9e12a4d-a70c-4546-ab90-68ce780cb37e',
  removeRestore: 'fd01370d-f621-4355-8cae-087fd7436898',
})

export const ViewPayItemConnectionGroup = groups.View
export const CreatePayItemConnectionGroup = groups.Create
export const EditPayItemConnectionGroup = groups.Edit
export const RemoveRestorePayItemConnectionGroup = groups.RemoveRestore
export const CreatePayItemConnection = connections.Create
export const ViewPayItemConnection = connections.View
export const EditPayItemConnection = connections.Edit
export const RemoveRestorePayItemConnection = connections.RemoveRestore
export const SyncPayItemConnection = Simple({
  action: 'Sync',
  page: ManagePayItems,
  id: '4f5e4177-9991-446c-8f00-920a4232b52f',
  object,
})

export type ManagePayItemsPermission =
  | typeof ViewPayItemConnectionGroup
  | typeof CreatePayItemConnectionGroup
  | typeof EditPayItemConnectionGroup
  | typeof RemoveRestorePayItemConnectionGroup
  | typeof CreatePayItemConnection
  | typeof ViewPayItemConnection
  | typeof EditPayItemConnection
  | typeof RemoveRestorePayItemConnection
  | typeof SyncPayItemConnection
